import React, { memo } from "react";
import PT from "prop-types";
import * as S from "./styled";
import PinIcon from "_c/icon/Pin";
import EyeOpenIcon from "_c/icon/EyeOpen";
import ClockIcon from "_c/icon/Clock";
import { Link } from "react-router-dom";
import { PREMIUM_ICON_URL } from "@/misc/constants";
import { normalizeRating } from "@/utils";
import MasterServices from "./Services";
import Avatar from "_c/Avatar";
import { SEARCH_NS as ns } from "@/i18n/ns";
import qs from "query-string";

const Master = ({ t, master, hl, ...props }) => {
  const isOnline = master.user.online;
  const isPremium = master.premium || master.saloon_meta?.premium;
  const address = master.location_hr || t(`${ns}:empty_address`);
  const openPopup = () => {
    props.openMapPopup({
      coords: master.location.coordinates,
      id: master._id,
    });
  };
  return (
    <S.Wrap isPremium={isPremium}>
      <S.InnerWrap>
        <S.TopSect>
          <Avatar
            online_at={master.user.online_at}
            reverseColors
            online={isOnline}
            size="lg"
            alt={"pro-" + [master.user.first_name, master.user.last_name].filter(Boolean).join("-") + "-in-lakki-place"}
            avatar={master.user.avatar}
          />
          <S.NameAndBadges>
            <S.Name>{master.user.first_name || ""}</S.Name>
            <S.Badges hl={hl} t={t} master={master} />
          </S.NameAndBadges>
        </S.TopSect>
        <S.ContentContainer>
          {master.reviews_count > 0 && (
            <S.ReviewsContainer>
              {isPremium && <img src={PREMIUM_ICON_URL} />}
              <S.Rate>{normalizeRating(master.rate)}</S.Rate>
              <S.ReviewsCount>
                {(master.reviews_count || 0) +
                  " " +
                  t("common:review", {
                    count: master.reviews_count || 0,
                  })}
              </S.ReviewsCount>
            </S.ReviewsContainer>
          )}
          <S.AddressContainer>
            <PinIcon width="15" color="white" />
            <address title={address}>{address}</address>
          </S.AddressContainer>
          <MasterServices t={t} services={master.services} />
          <S.Actions>
            <S.ActionButton onClick={() => props.openFreeSlots(master._id)}>
              <S.ActionIcon>
                <ClockIcon width="16" color="white" />
              </S.ActionIcon>
              <span>{t(`${ns}:free_slots`)}</span>
            </S.ActionButton>
            <S.ActionButton
              as={Link}
              to={qs.stringifyUrl({
                url: "/master",
                query: { hl, id: master._id },
              })}
            >
              <S.ActionIcon>
                <EyeOpenIcon width="19" color="white" />
              </S.ActionIcon>
              <span>{t(`${ns}:to_profile`)}</span>
            </S.ActionButton>
            <S.ActionButton onClick={openPopup}>
              <S.ActionIcon>
                <PinIcon width="13" color="white" />
              </S.ActionIcon>
              <span>{t(`${ns}:on_map`)}</span>
            </S.ActionButton>
          </S.Actions>
        </S.ContentContainer>
      </S.InnerWrap>
    </S.Wrap>
  );
};
Master.propTypes = {
  master: PT.object,
  hl: PT.string,

  openFreeSlots: PT.func.isRequired,
  openMapPopup: PT.func.isRequired,
  t: PT.func.isRequired,
};

export default memo(Master);
